import { AuthLibSettings } from './interfaces';

export function getRedirectUri(standalone = false): string {
  if (standalone) {
    return encodeURIComponent(`${location.origin}${location.pathname}`);
  }
  return encodeURIComponent(`${window.location.origin}/_auth`);
}

export function getState(navsid: string, id: number): string {
  return btoa(JSON.stringify({
    navsid,
    id
  }));
}

export function getCredentials(clientId: string, clientSecret: string): string {
  return btoa(`${clientId}:${clientSecret}`);
}

export function getUserAgent(): string {
  return btoa(encodeURIComponent(navigator.userAgent));
}

export function getDeviceName(deviceName: string): string {
  return btoa(encodeURIComponent(deviceName));
}

export function validateSettings(settings: AuthLibSettings): void {
  // required settings
  if (typeof settings.clientId !== 'string' || settings.clientId.length === 0) {
    throw new Error('Missing required setting clientId');
  }

  if (typeof settings.clientSecret !== 'string' || settings.clientSecret.length === 0) {
    throw new Error('Missing required setting clientSecret');
  }

  if (typeof settings.scope !== 'string' || settings.scope.length === 0) {
    throw new Error('Missing required setting scope');
  }

  if (typeof settings.oauthEndpointAuthorize !== 'string' || settings.oauthEndpointAuthorize.length === 0) {
    throw new Error('Missing required setting oauthEndpointAuthorize');
  }

  if (typeof settings.oauthEndpointToken !== 'string' || settings.oauthEndpointToken.length === 0) {
    throw new Error('Missing required setting oauthEndpointToken');
  }

  if (typeof settings.deviceName !== 'string' || settings.deviceName.length === 0) {
    throw new Error('Missing required setting deviceName');
  }

  // optional settings
  if (!!settings.mode && settings.mode !== 'standalone') {
    throw new Error(`Setting mode must be 'standalone' or undefined`);
  }

  if (!!settings.redirectUri && typeof settings.redirectUri !== 'string') {
    throw new Error('Setting redirectUri must be a string');
  }

  if (!!settings.authCode && typeof settings.authCode !== 'string') {
    throw new Error('Setting authCode must be a string');
  }

  if (!!settings.navsid && typeof settings.navsid !== 'string') {
    throw new Error('Setting navsid must be a string');
  }

  if (!!settings.authCodeTimeout && typeof settings.authCodeTimeout !== 'number') {
    throw new Error('Setting authCodeTimeout must be a number');
  }
}

/**
 * Returns the value of the given parameter from the given URL
 * @param paramName
 * @param url
 */
export function getUrlParam(paramName: string, url = location.href): string {
  const params = (new URL(url)).searchParams;
  return params.get(paramName);
}

/**
 * Navigates to the given URL
 * @param url
 */
/* istanbul ignore next function */
export function navigateTo(url: string): void {
  window.location.href = url;
}
